<div class="d-flex justify-content-between align-items-center rounded p-2" [ngClass]="{'border-none': buttonOnly, 'border border-1 border-dark': !buttonOnly}">
    @if (!buttonOnly) {
        <p class="w-100" #content>
            <ng-content></ng-content>
        </p>
    }
    <lib-button
        [ngClass]="{'scss-copy-position' : buttonOnly}"
        [iconOnly]="true"
        [prefixIcon]="Icon.Common.ContentCopy"
        [size]="ButtonSize.Large"
        [kind]="ButtonKind.NeutralTertiary"
        (clicked)="Copy()">
    </lib-button>
</div>
